webpackJsonp([253700561180811],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fp = __webpack_require__(11);
	
	var _dateFns = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	exports.default = function (_ref) {
	  var blogPost = _ref.blogPost;
	
	  var imageSrc = (0, _fp.get)('imageHeader.fields.file.url', blogPost);
	  var imageAlt = (0, _fp.get)('image.fields.description', blogPost);
	  var authorName = (0, _fp.get)('blogAuthor.fields.name', blogPost);
	  var authorSlug = '/' + (0, _fp.get)('blogAuthor.fields.slug', blogPost);
	  return _react2.default.createElement(
	    'div',
	    { itemID: '/' + blogPost.slug, itemScope: true, itemType: 'http://schema.org/LiveBlogPosting', className: 'LegacyPost stub' },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: '400px', overflow: 'hidden' }, className: 'blog-subheader' },
	      _react2.default.createElement('img', { itemProp: 'image', style: { width: '100%' }, src: imageSrc, alt: imageAlt })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container blog-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8 col-md-offset-2 blog_content' },
	        _react2.default.createElement(
	          'h2',
	          { itemProp: 'headline' },
	          blogPost.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'author_name' },
	          'By ',
	          _react2.default.createElement(
	            'a',
	            { itemScope: true, itemProp: 'Person', itemType: 'http://schema.org/Person', href: authorSlug },
	            _react2.default.createElement(
	              'span',
	              { itemProp: 'name' },
	              authorName
	            )
	          ),
	          ' on ',
	          _react2.default.createElement(
	            'span',
	            { itemProp: 'datePublished', content: blogPost.createdAt },
	            (0, _dateFns.format)(blogPost.createdAt, 'MMMM D, YYYY')
	          )
	        ),
	        _react2.default.createElement('p', { itemProp: 'description', className: 'intro', dangerouslySetInnerHTML: { __html: blogPost.intro } }),
	        _react2.default.createElement('link', { itemProp: 'sameAs', href: '/' + blogPost.slug }),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', href: '/' + blogPost.slug },
	          'READ MORE'
	        )
	      )
	    )
	  );
	}; // LIBS
	

	module.exports = exports['default'];

/***/ }),

/***/ 1965:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	__webpack_require__(1965);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fp = __webpack_require__(11);
	
	var _dateFns = __webpack_require__(17);
	
	var _util = __webpack_require__(12);
	
	var util = _interopRequireWildcard(_util);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	var _blogPostItem = __webpack_require__(56);
	
	var _blogPostItem2 = _interopRequireDefault(_blogPostItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	
	
	// COMPONENTS
	
	
	// LIBS
	var query = exports.query = '** extracted graphql fragment **';
	
	// HELPERS
	// STYLE
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  // grab and sort blogPost data from graphql query result (oldest to newest)
	  var nodes = (0, _fp.sortBy)(function (item) {
	    return new Date(item.createdAt);
	  }, (0, _fp.map)((0, _fp.get)('node'), (0, _fp.get)('allBlogJson.edges', data))).reverse();
	  return _react2.default.createElement(
	    'div',
	    { className: 'BlogIndex' },
	    _react2.default.createElement(_metaData2.default, { data: {
	        slug: 'blog',
	        title: 'Blog',
	        description: 'Code Fellows Blog'
	      } }),
	    _react2.default.createElement(
	      'div',
	      { style: { paddingTop: '70px' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        nodes.map(function (node, i) {
	          return _react2.default.createElement(_blogPostItem2.default, { key: i, blogPost: node });
	        })
	      )
	    )
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-index-js-cb51e374c1591d1ca250.js